module.exports = __webpack_public_path__ + "img/yuyin-radio-icon.98a02cb4.png";